export default "__VITE_ASSET__CWrQ7uqi__"